import _regeneratorRuntime from "D:/projectMenu/feedback/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/projectMenu/feedback/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-15cbfe1c"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  "class": "name"
};
var _hoisted_2 = {
  "class": "text"
};
import Activity from '@/common/components/Activity.vue';
import { useNavigation } from '@/common/util/navigation';
import { t } from '@/i18n';
import { postApiFeedbackMark } from '@/service/api';
import { feedbackInfoAction } from '@/util/event';
import { onBeforeMount } from 'vue';
import { useRoute } from 'vue-router';
export default /*#__PURE__*/_defineComponent({
  setup: function setup(__props) {
    var _useNavigation = useNavigation(),
      toBack = _useNavigation.toBack;
    var route = useRoute();
    onBeforeMount(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return postApiFeedbackMark({
              id: route.params.id,
              openId: window.openid,
              mark: 1
            });
          case 2:
            feedbackInfoAction.emit('close');
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    return function (_ctx, _cache) {
      return _openBlock(), _createBlock(Activity, {
        "class": "FeedbackInfoSuccessView"
      }, {
        "default": _withCtx(function () {
          return [_createElementVNode("div", {
            "class": "close",
            onClick: _cache[0] || (_cache[0] =
            //@ts-ignore
            function () {
              return _unref(toBack) && _unref(toBack).apply(void 0, arguments);
            })
          }), _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(t)('submitSuccess')), 1), _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('submitSuccessDescPrefix')) + "~", 1)];
        }),
        _: 1
      });
    };
  }
});